import angular from 'angular';
import UnsubscribeFormController from "./unsubscribe-form.controller";

let yourclub = angular
    .module('yourclub', [])
    .controller('UnsubscribeFormController', UnsubscribeFormController);

export default yourclub;

